
jQuery(function ($) {

    //マウスを乗せたら発動
    $('.p-fruits--single .f-bg-list .f-bg-list__imgbox').hover(function () {

        //マウスを乗せたら色が変わる
        const hover_img = $(this).html();
        $('.p-fruits--single .f-wr-tb .f-bg-img').html(hover_img);
    });
});
